
let color = [
    "#8B5CFF",
    "#00CA69"
];

// let xAxisData = ["1", "2", "3", "4", "5", "6", "7", "8"];
let yAxisData1 = [100, 138, 350, 173, 180, 150, 180, 230];
let yAxisData2 = [233, 233, 200, 180, 199, 233, 210, 180];

const hexToRgba = (hex, opacity) => {
    let rgbaColor = "";
    let reg = /^#[\da-f]{6}$/i;
    if (reg.test(hex)) {
        rgbaColor = `rgba(${parseInt("0x" + hex.slice(1, 3))},${parseInt(
      "0x" + hex.slice(3, 5)
    )},${parseInt("0x" + hex.slice(5, 7))},${opacity})`;
    }
    return rgbaColor;
}

export const echartTemp  = [
  {
    color: color,
    legend: {
      top: 'top',
      textStyle: {}
    },
    tooltip: {
      trigger: "axis",
      
      extraCssText: 'background: rgba(255, 255, 255, 0.3); padding: 10px; border: 1px solid rgba(0, 0, 0, 0.2);; border-radius: 0;box-shadow: 0 0 3px rgba(0, 0, 0, 0.2);color: #333;',
      axisPointer: {
        type: 'shadow',
        shadowStyle: {
          color: 'rgba(225,225,225,0.3)',
          shadowColor: 'rgba(225,225,225,0.3)',
          shadowBlur: 5
        }
      }
    },
    grid: {
      top: 20,
      containLabel: true
    },
    xAxis: [{
      type: "category",
      boundaryGap: false,
      axisLabel: {
        textStyle: {
          color: "#333"
        }
      },
      axisLine: {
        lineStyle: {
          color: "#D9D9D9"
        }
      },
      data: [],
      // data: xAxisData,
    }],
    yAxis: [{
      type: "value",
      axisLabel: {
        textStyle: {
          color: "#666"
        }
      },
      nameTextStyle: {
        color: "#666",
        fontSize: 12,
        lineHeight: 40
      },
      // 分割线
      splitLine: {
        lineStyle: {
          type: "dashed",
          color: "#E9E9E9"
        }
      },
      axisLine: {
        show: false
      },
      axisTick: {
        show: false
      }
    }],
    series: [{
      // name: "2018",
      name: "预测出电量",
      type: "line",
      smooth: true,
      symbolSize: 8,
      zlevel: 3,
      lineStyle: {
        normal: {
          color: color[0],
          shadowBlur: 3,
          shadowColor: hexToRgba(color[0], 0.5),
          shadowOffsetY: 8
        }
      },
      symbol: 'circle',//数据交叉点样式
      areaStyle: {
        normal: {
          color: '#ffffff',
          shadowColor: hexToRgba(color[0], 0.1),
          shadowBlur: 10
        }
      },
      data: yAxisData1
    }, {
      name: "实际用电量",
      type: "line",
      smooth: true,
      symbolSize: 8,
      zlevel: 3,
      lineStyle: {
        normal: {
          color: color[1],
          shadowBlur: 3,
          shadowColor: hexToRgba(color[1], 0.5),
          shadowOffsetY: 8
        }
      },
      symbol: 'circle',//数据交叉点样式 (实心点)
      areaStyle: {
        normal: {
          color: '#ff0000',
          shadowColor: hexToRgba(color[1], 0.1),
          shadowBlur: 10
        }
      },
      data: yAxisData2
    }]
  },
];